import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllSchools as apiRestoreAllSchools } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllSchools() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: restoreAllSchools, isPending: isRestore, data: results, error } = useMutation({
        mutationFn: (req) => apiRestoreAllSchools(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { restoreAllSchools, isRestore, error, results };
}
